import React, { Component } from 'react'
import * as d3 from "d3";
import elementResizeEvent from 'element-resize-event'

class MeterChart extends Component {
  constructor(props){
    super(props);

    this.state = {
      width: this.props.width,
    }
  }

  componentDidMount() {
    this.setChartWidth()
    var charName = this.props.name
    var chart = document.getElementById(charName)
    elementResizeEvent(chart, () => this.setChartWidth())
  }

  setChartWidth = () => {
    var charName = this.props.name
    var chart = document.getElementById(charName)
    this.setState({
      width: chart.offsetWidth,
    })
  }

  createMeterChart() {
    var charName = this.props.name
    var value = this.props.value
    var width = this.state.width
    var radius = this.props.radius
    var labelWidth = this.getTextWidth("0100") + 10

    if(((radius * 2) + labelWidth + 20) > width) {
      radius = (width - labelWidth) / 2.0 - 20
    }

    const FONT_SIZE = radius / 2.0
    var height = radius + FONT_SIZE + 10
    var position_x = width / 2.0 - (this.getTextWidth("0100")) / 2.0 + 1
    var position_y = height - FONT_SIZE - 5
    var degrees = value * (180.0 / 100.0) // convertion of value to angle in semi circle (100% = 180˚)

    var chart = d3.select("#" + charName)
    chart.selectAll("svg").remove() //remove previously created chart

    //add canvas area
    var svg = chart.append("svg")
         .attr("width", width)
         .attr("height", height + 10)

    //add progress chart
    this.meter(svg, position_x, position_y, radius, degrees)
    this.indicator(svg, position_x, position_y, radius + 5, degrees, (2 * (FONT_SIZE / 14)))
    this.addTextLabel(svg, position_x - radius, position_y, "0", "left")
    this.addTextLabel(svg, position_x + radius, position_y, "100", "right")
    this.addTextLabel(svg, position_x, position_y + FONT_SIZE + 10, this.props.value + "%", "center", FONT_SIZE, 'Arial bold', "black")
  }

  meter(svg, x, y, radius, degrees) {
    // radius =
    var arc = d3.arc();
    // add semi circle
    svg.append('path')
       .attr('transform', 'translate('+[x, y]+') rotate(-90)')
       .attr("fill", "#dedede")
       .attr('d', arc({
         innerRadius: 0,
         outerRadius: radius,
         startAngle: 0,
         endAngle: Math.PI
       }));

      // add progress
     return svg.append('path')
       .attr('transform', 'translate('+[x, y]+') rotate(-90)')
         .attr("fill", "rgba(200,230,50)")
       .attr('d', arc({
          innerRadius: 0,
          outerRadius: radius,
          startAngle: 0,
          endAngle: degrees * Math.PI / 180.0
        }));
  }

  indicator(svg, x, y, length, degrees, pointer_width=8) {
    //add pointer
    svg.append('rect')
      .attr('transform', 'translate(' + [x, y - (pointer_width / 2.0)] + ') rotate(' + (-180 + degrees) + ' '+ 0 + ' ' + (pointer_width / 2.0) + ')')
      .attr("fill", "black")
      .attr("width", length)
      .attr("height", pointer_width)

    //add circle fixed point of pointer
    return svg.append('circle')
      .attr("cx", x)
      .attr("cy", y)
      .attr("r", pointer_width)
      .attr("fill", "black")
  }

  addTextLabel(svg, x, y, text, direction="center", fontSize=14, fontFace='Arial bold', color="#888") {
    var text_width = this.getTextWidth(text, fontSize, fontFace)

    if(direction === "left") {
      x = x - text_width - 5
    }
    else if(direction === "right") {
      x = x + 5
    }
    else {
      x = x - (text_width / 2.0)
    }

    return svg.append('text')
      .attr("x", x)
      .attr("y", y)
      .attr("fill", color)
      .attr("font-size", fontSize + 'px')
      .style("font-weight", "bold")
      .text(text)
  }

  getTextWidth(text, fontSize=14, fontFace='Arial bold') {
    var canvas = document.createElement('canvas')
    var context = canvas.getContext('2d')
    context.font = fontSize + 'px ' + fontFace
    return context.measureText(text).width
  }

  render() {
    return (
      <div className='meter-chart'>
        <div className='chart-title'>
          { this.props.label }
        </div>
        <div className="chart-area" id={ this.props.name }>
          { this.createMeterChart() }
        </div>
      </div>
    )
  }
}

export default MeterChart;



// WEBPACK FOOTER //
// ./src/views/components/charts/meter_chart.js